import React, { useEffect } from 'react';

import { PaymentStatusView } from 'enums';
import { useOrderContext } from 'hooks';
import { PaymentStatusViewProps } from 'types';

import { SqPaymentStatusLayout } from './SqPaymentStatusLayout';
import { SqPaymentReceiptsDispute } from '../SqPaymentReceiptsDispute';

export const SqPaymentStatus: React.FC<PaymentStatusViewProps> = ({
  canManageReceipts,
}) => {
  const {
    paymentStatusView,
    refetchOrder,
    receiptsResult: { isUploadingReceipt, setReceiptUploadCallbacks },
  } = useOrderContext();
  const showReceipts =
    canManageReceipts &&
    paymentStatusView !== PaymentStatusView.Processing &&
    !isUploadingReceipt;

  useEffect(() => {
    if (showReceipts) {
      setReceiptUploadCallbacks(refetchOrder, () => {});
    }
  }, [showReceipts, refetchOrder, setReceiptUploadCallbacks]);

  return (
    <SqPaymentStatusLayout>
      {showReceipts && <SqPaymentReceiptsDispute />}
    </SqPaymentStatusLayout>
  );
};
